export default "__VITE_ASSET__bc678b38__"